export const RQ_GENERATE_OTP_EMAIL = {
  url: 'api/otp/generate/email?email=<%= email %>',
  method: 'POST',
  auth: false,
};

export const RQ_VERIFY_OTP_EMAIL = {
  url: 'api/otp/verify/email',
  method: 'POST',
  auth: false,
  search: true,
};
export const RQ_GENERATE_OTP_MOBILE = {
  url: 'api/otp/generate/mobile?phoneNumber=<%= phoneNumber %>',
  method: 'POST',
  auth: false,
};

export const RQ_VERIFY_OTP_MOBILE = {
  url: 'api/otp/verify/mobile?phoneNumber=<%= phoneNumber %>&otp=<%= otp %>',
  method: 'POST',
  auth: false,
};
